import { Typography } from "@mui/material";
import { useState } from "react";

import BasicButton from "../../../ui library/components/buttons/BasicButton";

import AddReferralItem from "./AddReferralItem";

export default function AddReferralForm({ caseId, submit }) {
  function generateRandomId() {
    return { id: Date.now() + Math.random() };
  }

  const [referralList, setReferralList] = useState([generateRandomId()]);

  const handleAddRow = () => {
    setReferralList((prev) => [...prev, generateRandomId()]);
  };

  const handleDeleteRow = (id) => {
    setReferralList((prev) => prev.filter((item) => item.id !== id));
  };

  const handleOnChangeRow = (id, param, value) => {
    setReferralList((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, [param]: value?.id ? value.id : value } : item
      )
    );
  };

  return (
    <div className="flex h-full min-h-80 w-full flex-col items-center items-stretch bg-white p-6">
      <div>
        <Typography className="text-center text-xl font-bold text-black">Add Referral/s</Typography>
      </div>
      <div className="m-4 flex w-full flex-col justify-center">
        {referralList.map((item) => (
          <AddReferralItem
            caseId={caseId}
            key={item.id}
            onDelete={() => handleDeleteRow(item.id)}
            onChange={(param, value) => handleOnChangeRow(item.id, param, value)}
          />
        ))}
      </div>
      <div className="flex w-full flex-row justify-end gap-4">
        <BasicButton disabled={false} text="Add Row" className={`w-32`} onClick={handleAddRow} />
        <BasicButton
          disabled={referralList.length === 0}
          text="Submit"
          className={`w-32 bg-green-600 hover:bg-green-700`}
          onClick={() => submit(referralList)}
        />
      </div>
    </div>
  );
}
